import Vue from 'vue'
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    "@/locales", // Путь к папке с нашими json файлами локализации
    true,
    /[A-Za-z0-9-_,.\s]+\.json$/i
  );
  const messages:any = {};
  locales.keys().forEach(key => {
    const matched = key.slice(2).split('.');
    if (matched && matched.length == 2) {
      const locale = matched[0];

      messages[locale] = Object.assign({},messages[locale],locales(key));
    }

    if (matched && matched.length == 3) {
      const locale = matched[1];

      let ind:string = matched[0], ob:any = {};

      ob[ind] =  locales(key);

      messages[locale] = Object.assign({},messages[locale],ob);


    }


  });
  return messages;
}
function checkDefaultLanguage() { //Определяем язык браузера
  let matched = null;
  let languages = Object.getOwnPropertyNames(loadLocaleMessages());
  languages.forEach(lang => {
    if (lang === navigator.language) {
      matched = lang;
    }
  });
  if (!matched) {
    languages.forEach(lang => {
      let languagePartials = navigator.language.split("-")[0];
      if (lang === languagePartials) {
        matched = lang;
      }
    });
  }
  return matched;
}
export const selectedLocale = localStorage.getItem('locale') || "ru";
export const languages = Object.getOwnPropertyNames(loadLocaleMessages());
export default new VueI18n({
  locale: selectedLocale || "ru",
  fallbackLocale: "ru",
  messages: loadLocaleMessages()
});
